module.exports = __webpack_public_path__ + "static/media/transition-white.1a0aa4b9.svg";